import { HomePage } from "./pages"

export const homeRoutes = (): any => {
    return [
        {
            path: "/home",
            name: "Home page",
            element: <HomePage />
        }
    ]
}